import React from 'react';
import { FileX, Search, Plus, RefreshCw } from 'lucide-react';

const EmptyState = ({ 
  icon: Icon = FileX,
  title = "Aucune donnée trouvée",
  description = "Il n'y a actuellement aucun élément à afficher.",
  actionLabel,
  onAction,
  showRefresh = false,
  onRefresh,
  className = ""
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}>
      <div className="w-16 h-16 mx-auto mb-4 text-gray-400">
        <Icon className="w-full h-full" />
      </div>
      
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        {title}
      </h3>
      
      <p className="text-sm text-gray-500 mb-6 max-w-sm">
        {description}
      </p>
      
      <div className="flex items-center gap-3">
        {actionLabel && onAction && (
          <button
            onClick={onAction}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <Plus className="w-4 h-4 mr-2" />
            {actionLabel}
          </button>
        )}
        
        {showRefresh && onRefresh && (
          <button
            onClick={onRefresh}
            className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Actualiser
          </button>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
